export const en = {
  nav: {
    discover: "Discover",
    creators: "Creators",
    howItWorks: "How it works",
    forCreators: "For Creators",
    about: "About",
    legal: "Legal",
    waitlist: "Join Waitlist",
    signIn: "Sign In",
    comingSoon: "Coming Soon",
    menu: "Menu",
  },
  hero: {
    badge18: "18+",
    comingSoon: "Coming Soon",
    eyebrow: "The Experience Engine",
    lines: ["Discover creators.", "Live their experience."],
    sub: "A new way to discover exclusive content, connect with creators and unlock experiences that go beyond a simple post.",
    definition: "GOOX is an adult creator platform connecting creators, fans and exclusive digital experiences.",
    ctaFans: "Discover GOOX",
    ctaCreators: "Become a Creator",
    devNotice: "GOOX is currently in development. Registration, purchases and content uploads are not yet available.",
    steps: ["Discover", "Choose", "Unlock", "Collect", "Connect"],
    card1Label: "Upcoming live · Concept",
    card1Title: "Live training — subscribers only",
    card1Creator: "Kai Moreno · fictional profile",
    card2Label: "Exclusive release · Concept",
    card2Title: "Midnight — Launch bundle",
    card2Meta: "Limited · 100 units · transparent window",
    operated: "Operated by CAP GROUP S.A.S. · Colombia",
  },
  marquee: ["Discover", "Choose", "Unlock", "Collect", "Connect", "Live", "Series", "Collections", "Limited releases"],
  what: {
    eyebrow: "01 — What is GOOX",
    title: "More than content. An experience.",
    body: "GOOX is an adult creator platform (18+) connecting creators, fans and exclusive digital experiences: subscriptions, collections, series, limited releases and personalized experiences. Every piece is presented as a product: clear value, transparent pricing and no hidden mechanics.",
    pillars: [
      { t: "Transparent value", d: "Fans see exactly what they unlock before they pay. No surprises, no dark patterns." },
      { t: "Real scarcity", d: "Limited releases with visible units and time windows — never artificial countdowns." },
      { t: "Creator ownership", d: "Creators keep control of their catalog, pricing and audience relationships." },
    ],
  },
  creators: {
    eyebrow: "02 — For Creators",
    title: "Your content. Your audience. Your business.",
    sub: "A studio designed to turn a catalog into a business — with tools for publishing, packaging and understanding your revenue.",
    items: [
      { t: "Create your profile", d: "A public page that presents your identity, catalog and exclusive offers." },
      { t: "Publish content", d: "Posts, photos, video and audio with granular visibility controls." },
      { t: "Build collections", d: "Group pieces into thematic bundles with their own price and story." },
      { t: "Create series", d: "Release content by episodes — like quests your fans follow over time." },
      { t: "Launch exclusive releases", d: "Limited drops with visible units, dates and transparent windows." },
      { t: "Connect with your fans", d: "Direct messaging, live moments and closer relationships." },
      { t: "Track your earnings", d: "A clear dashboard for revenue, unlocks and audience growth." },
    ],
    cta: "Become a Creator",
  },
  fans: {
    eyebrow: "03 — For Fans",
    title: "Discover creators you'll love.",
    sub: "Come to discover, not just to subscribe. Every profile shows the value before you decide.",
    items: [
      { t: "Discover", d: "Explore creators by category, style and format." },
      { t: "Follow", d: "Stay close to the creators you care about." },
      { t: "Subscribe", d: "Recurring access to a creator's exclusive world." },
      { t: "Unlock", d: "Pay once for a single piece, collection or release." },
      { t: "Collect", d: "Build your personal library of unlocked experiences." },
      { t: "Support creators", d: "Your support goes directly to the people you follow." },
    ],
    cta: "Join the Waitlist",
  },
  engine: {
    eyebrow: "04 — The Experience Engine",
    title: "Turn content into experiences.",
    sub: "The same piece of content can become many products. GOOX gives creators the formats; fans get clarity on what they unlock.",
    source: "Content",
    outputs: [
      { k: "POST", t: "Post", d: "Public or subscriber-only publication." },
      { k: "PPV", t: "Pay-per-view", d: "Single piece, unlocked once." },
      { k: "COLLECTION", t: "Collection", d: "Curated bundle with its own price." },
      { k: "SERIES", t: "Series", d: "Episodic releases fans follow." },
      { k: "RELEASE", t: "Exclusive release", d: "Limited drop with visible units." },
      { k: "LIVE", t: "Live", d: "Real-time moments for subscribers." },
    ],
  },
  how: {
    eyebrow: "05 — How it works",
    title: "Five steps. Zero friction.",
    steps: [
      { n: "01", t: "Discover", d: "Browse creators publicly — no account needed to explore." },
      { n: "02", t: "Choose", d: "Compare formats: subscription, single unlock, collection or release." },
      { n: "03", t: "Unlock", d: "Pay with a clear price and a clear description. Always." },
      { n: "04", t: "Collect", d: "Everything you unlock lives in your library." },
      { n: "05", t: "Connect", d: "Message, join lives and follow series as they unfold." },
    ],
  },
  waitlist: {
    eyebrow: "Pre-launch",
    title: "Join the GOOX Waitlist",
    sub: "Be the first to know when GOOX opens. We'll only use your email to contact you about the launch.",
    email: "Email address",
    emailPh: "you@example.com",
    iam: "I am a",
    roles: { fan: "Fan", creator: "Creator", agency: "Agency / Studio" },
    consent: "I authorize CAP GROUP S.A.S. to process my personal data to contact me about the GOOX launch, in accordance with the",
    consentLink: "Privacy Policy",
    consentRequired: "You must accept the data processing authorization.",
    submit: "Join the Waitlist",
    submitting: "Joining…",
    success: "You're on the list. We'll be in touch when GOOX opens.",
    duplicate: "This email is already on the waitlist.",
    error: "Something went wrong. Please try again.",
    invalidEmail: "Please enter a valid email address.",
    note: "No account is created. No payment is requested.",
  },
  footer: {
    tagline: "The new creator experience.",
    platform: "Platform",
    company: "Company",
    legal: "Legal",
    forFans: "For Fans",
    forCreators: "For Creators",
    contact: "Contact",
    rights: "All rights reserved.",
    ageNotice: "This website is intended for adults aged 18 or older. GOOX is a pre-launch presentation; no user accounts, purchases or user content are available yet.",
    operatedBy: "GOOX is a brand operated by",
  },
  legalTitles: {
    terms: "Terms & Conditions",
    privacy: "Privacy Policy",
    cookies: "Cookie Policy",
    refunds: "Refund Policy",
    content: "Content Policy",
    dmca: "DMCA / Copyright",
    "age-safety": "Age & Safety",
    "creator-terms": "Creator Terms",
    "acceptable-use": "Acceptable Use Policy",
    complaints: "Complaints / Contact",
  },
  legal: {
    title: "Legal",
    sub: "Policies governing the GOOX pre-launch website and the future platform, operated by CAP GROUP S.A.S.",
    updated: "Last updated",
    disclaimer: "Draft documents prepared specifically for GOOX and CAP GROUP S.A.S. Final versions are subject to review by legal counsel in Colombia.",
    toc: "Documents",
    back: "Back to home",
  },
  discover: {
    eyebrow: "Concept preview",
    title: "Discover creators.",
    sub: "A conceptual preview of the GOOX Discover experience. All profiles are fictional and all content is a placeholder.",
    notice: "Conceptual demo — fictional profiles, no real content, no purchases. Interactions will be enabled when the platform launches.",
    search: "Search creators, collections…",
    all: "All",
    follow: "Follow",
    subscribe: "Subscribe",
    locked: "Locked",
    pieces: "pieces",
    fans: "fans",
    fictional: "Fictional profile",
    comingSoon: "Coming soon",
    empty: "No creators match your search.",
  },
  about: {
    eyebrow: "About GOOX",
    title: "A creator platform built in Colombia, designed for the world.",
    intro: "GOOX is an adult creator platform (18+) operated by CAP GROUP S.A.S., a company incorporated in Colombia. GOOX is being developed as a platform connecting creators, agencies and fans through exclusive digital content, subscriptions and digital experiences.",
    statusTitle: "Current status",
    status: "GOOX is in development. This website is a public pre-launch presentation: it explains the brand, the business model and the legal framework, and collects a waitlist. Registration, payments, content upload and access to real content are not available yet.",
    missionTitle: "Mission",
    mission: "Give creators a professional place to turn their work into clear, fairly priced experiences — and give fans transparency on what they unlock.",
    modelTitle: "Business model (planned)",
    model: [
      { t: "Subscriptions", d: "Recurring monthly access to a creator's exclusive content." },
      { t: "Pay-per-view unlocks", d: "One-time purchase of a single piece, collection or series." },
      { t: "Exclusive releases", d: "Limited-quantity drops with visible units and time windows." },
      { t: "Live experiences", d: "Real-time sessions for subscribers or ticket holders." },
      { t: "Platform fee", d: "GOOX retains a percentage of each transaction; the remainder is paid to the creator." },
    ],
    complianceTitle: "Compliance commitments",
    compliance: [
      "18+ only: all users and creators must be adults; creators will complete identity and age verification (KYC) before publishing.",
      "Content moderation: a content policy, review process and takedown procedure apply to all published material.",
      "Copyright: a DMCA / copyright notice and takedown process with a designated contact.",
      "Consumer protection: transparent pricing, clear descriptions and a written refund policy.",
      "Data protection: personal data processed under Colombian Law 1581 of 2012 and Decree 1377 of 2013.",
      "Payments: processed exclusively through licensed payment service providers; GOOX never stores card data.",
    ],
    companyTitle: "Legal entity",
    fields: {
      legalName: "Legal name",
      nit: "Tax ID (NIT)",
      registry: "Commercial registry No.",
      chamber: "Registered at",
      registeredAt: "Registration date",
      renewedAt: "Last renewal",
      niif: "IFRS group",
      address: "Registered address",
      email: "Email",
      phones: "Phone",
      domain: "Domain",
      brand: "Brand",
    },
    roadmapTitle: "Roadmap",
    roadmap: [
      { n: "Phase 1", t: "Landing + Waitlist + Legal", d: "Public brand presentation and underwriting-ready documentation.", now: true },
      { n: "Phase 2", t: "Discover + public profiles", d: "Public exploration of creators and catalogs." },
      { n: "Phase 3", t: "Fan & creator registration", d: "Accounts, verification and creator onboarding." },
      { n: "Phase 4", t: "Full platform", d: "Subscriptions, unlocks, releases, lives, wallet and payouts." },
      { n: "Phase 5", t: "GOOX international", d: "Multi-currency, multi-language expansion." },
    ],
    contactTitle: "Contact",
    contact: "For business, compliance or legal inquiries, contact CAP GROUP S.A.S. using the details above or through the Complaints / Contact page.",
    current: "Current phase",
  },
  admin: {
    title: "Waitlist admin",
    sub: "Restricted area · CAP GROUP S.A.S.",
    password: "Admin password",
    login: "Sign in",
    loggingIn: "Signing in…",
    logout: "Sign out",
    invalid: "Invalid password.",
    locked: "Too many attempts. Try again in 15 minutes.",
    total: "Total signups",
    fans: "Fans",
    creators: "Creators",
    agencies: "Agencies",
    search: "Search by email…",
    all: "All roles",
    export: "Export CSV",
    refresh: "Refresh",
    empty: "No signups yet.",
    delete: "Delete",
    deleted: "Entry deleted.",
    cols: { email: "Email", role: "Role", lang: "Language", date: "Date", consent: "Consent" },
    roles: { fan: "Fan", creator: "Creator", agency: "Agency / Studio" },
  },
  notFound: { title: "Page not found", body: "This page does not exist or is not available yet.", cta: "Back to home" },
  status: {
    eyebrow: "06 — Platform status",
    title: "Platform currently in development.",
    body: "GOOX is a pre-launch presentation. What you see here is the brand, the business model and the legal framework. Registration, payments, content uploads and access to real content are not available yet.",
    operatedBy: "Operated by",
    entity: "Legal entity",
    canTitle: "What visitors can do today",
    can: ["Explore the brand and how GOOX works", "Browse the conceptual Discover preview (fictional profiles)", "Read the corporate information and all legal policies", "Join the waitlist as fan, creator or agency"],
    cannotTitle: "Not available yet",
    cannot: ["Create an account or sign in", "Buy, subscribe or unlock content", "Upload or publish content", "Message creators or join lives"],
    aboutCta: "About GOOX & CAP GROUP S.A.S.",
    legalCta: "Legal documents",
  },
  login: {
    eyebrow: "Sign in",
    title: "GOOX is preparing for launch.",
    body: "Join the waitlist to be notified when access becomes available. There are no public user accounts yet — we are not pretending otherwise.",
    cta: "Join the waitlist",
    back: "Back to home",
    demoEyebrow: "Reviewer / demo access",
    demoTitle: "Demo account for payment processors & reviewers",
    demoBody: "A sandbox account that shows how the GOOX member area will look and work. Fictional creators, placeholder content and simulated transactions — no real payments are processed.",
    username: "Demo username",
    password: "Demo password",
    submit: "Enter demo",
    submitting: "Signing in…",
    invalid: "Invalid username or password.",
    locked: "Too many attempts. Try again in 15 minutes.",
  },
  demo: {
    banner: "Demo account — conceptual preview for reviewers. Fictional profiles, placeholder content, simulated transactions. No real payments are processed.",
    ribbon: "DEMO",
    nav: { home: "Home", discover: "Discover", following: "Following", collections: "Collections", messages: "Messages", wallet: "Wallet", profile: "Profile", live: "Live", library: "My library", security: "Security", studio: "Creator Studio", signOut: "Sign out", fanView: "Fan view", creatorView: "Creator view", backToSite: "Back to goox.vip" },
    search: "Search creators, pieces…",
    tokens: "tokens",
    add: "Add",
    toastPay: "Demo mode: purchases and payments are disabled.",
    toastMsg: "Demo mode: messaging is read-only.",
    types: { POST: "Post", PPV: "Pay-per-view", COLLECTION: "Collection", SERIES: "Series", RELEASE: "Exclusive release", LIVE: "Live", SUB: "Subscription" },
    home: {
      eyebrow: "The Experience Engine",
      line1: "I'm not here just to subscribe.",
      line2: "I'm here to discover.",
      sub: "Every piece is a product: episodic Series, real limited Releases, Collections, single Unlocks and Lives. You see the value before you pay.",
      cta1: "Explore Discover",
      cta2: "View Series",
      upcomingLive: "Upcoming live",
      activeDrop: "Active drop",
      dropsTitle: "Active drops",
      dropsSub: "Real scarcity: visible units and transparent windows.",
      viewAll: "View all",
      feedTitle: "For you",
      feedSub: "Pieces from creators you follow.",
      unlock: "Unlock",
      subscribe: "Subscribe",
      unlocked: "Unlocked",
      subscribers: "Subscribers only",
      live: "LIVE",
      soldOut: "Sold out",
      presale: "Presale",
      units: "units",
    },
    following: { title: "Following", sub: "Creators you follow and your active subscriptions.", active: "Active subscription", renews: "Renews", follow: "Following", subscribe: "Subscribe", manage: "Manage", perMonth: "/mo" },
    collections: { title: "My library", sub: "Everything you unlocked lives here — forever.", pieces: "pieces", paid: "Paid", open: "Open", acquired: "Acquired" },
    messages: { title: "Messages", sub: "Direct conversations with the creators you support.", ppv: "Locked message", unlockFor: "Unlock for", placeholder: "Write a message… (read-only in demo)", send: "Send" },
    wallet: {
      title: "Wallet", sub: "Tokens are prepaid credits used to unlock pieces. Subscriptions are billed in USD.", balance: "Token balance", equivalent: "≈ USD equivalent", addFunds: "Add tokens", packs: "Token packs", buy: "Buy",
      history: "Transaction history", date: "Date", desc: "Description", amount: "Amount", method: "Payment method", processor: "Card via licensed PSP (simulated)", disabled: "Payments are not enabled in the demo. In production, all card payments will be processed by a licensed payment service provider; GOOX never stores card data.",
      kinds: { topup: "Top-up", sub: "Subscription", unlock: "Unlock" },
    },
    profile: { title: "Profile", sub: "Your GOOX identity as a fan.", username: "Username", email: "Email", role: "Account type", member: "Member since", status: "Status", verified: "Age verified (18+)", demoRole: "Demo fan account", lang: "Language", edit: "Edit profile" },
    security: { title: "Account security", sub: "Controls that will be available to every GOOX account.", items: ["Two-factor authentication (TOTP / email)", "Active sessions and device management", "Blocked creators and users", "Content visibility & privacy preferences", "Download your data / delete account", "Age verification status"] },
    studio: {
      title: "Creator Studio", sub: "How a verified creator sees their business on GOOX (demo data).", earnings: "Earnings · last 30 days", subscribers: "Active subscribers", unlocks: "Unlocks · 30 days", pending: "Pending (holding period)", available: "Available for payout", nextPayout: "Next payout", request: "Request payout",
      split: "Revenue split", splitNote: "of every transaction goes to the creator; GOOX retains the platform fee. Payouts are released after a holding period for fraud and chargeback protection.", creator: "Creator", platform: "GOOX fee", holding: "day holding period",
      top: "Top content", type: "Type", sales: "Sales", revenue: "Revenue", payouts: "Payout history", paid: "Paid",
    },
  },
  ageGate: {
    eyebrow: "Age verification",
    title: "This site is for adults only.",
    body: "GOOX is a creator platform intended exclusively for persons aged 18 or older. By entering you confirm that you are at least 18 years old (or the age of majority in your jurisdiction) and that viewing this type of content is legal where you are located.",
    legal: "By entering you also accept our",
    and: "and",
    enter: "I am 18+ — Enter",
    exit: "Under 18 — Leave",
    operated: "Operated by",
  },
};
